export const SHOW_STUDENT_ACCESS_FIELD = "showStudentAccess"

export function shouldShowStudentAccess(userProfile) {
	return userProfile?.extraProps?.[SHOW_STUDENT_ACCESS_FIELD] === true
}

export function setShowStudentAccess(userProfile, value) {
	if(!userProfile){
		return null
	}
	if(!userProfile.extraProps){
		userProfile.extraProps = {}
	}
	userProfile.extraProps[SHOW_STUDENT_ACCESS_FIELD] = value === true
	return userProfile
}

export function mergeShowStudentAccess(extraProps = {}, value) {
	return {
		...extraProps,
		[SHOW_STUDENT_ACCESS_FIELD]: value === true
	}
}
